import { ICollection } from '@monofront/types';
import { useUserTags } from '@monofront/business/hooks';
import {
  COLLECTIONS_TAGS,
  FRESH_USER,
  ULTRA_FRESH_USER,
} from '@monofront/business/constants';
import { useMemo } from 'react';
import { useCacheFirstAuthentication } from '@context/persistedAuthContext';
import { useTranslations } from 'next-intl';
import CardsList from '@components/CardsList';

interface ISiblingCollectionsCardListProps {
  siblingCollections?: ICollection[] | null;
  UNSAFE_className?: string;
}

export const SiblingCollectionsCardList: React.FC<
  ISiblingCollectionsCardListProps
> = ({ siblingCollections, UNSAFE_className }) => {
  const localTags = useUserTags(useCacheFirstAuthentication);
  const defaultCollectionVisualPath = '/images/default-collection-visual.jpg';
  const tCatalog = useTranslations('Catalog');

  const displayedCollections = useMemo(() => {
    return (
      siblingCollections?.filter(
        (collection) =>
          (!collection._tags?.includes(COLLECTIONS_TAGS.FRESH) ||
            localTags.includes(FRESH_USER)) &&
          (!collection._tags?.includes(COLLECTIONS_TAGS.ULTRA_FRESH) ||
            localTags.includes(ULTRA_FRESH_USER)),
      ) || []
    );
  }, [siblingCollections]);

  if (displayedCollections.length === 0) {
    return null;
  }

  return (
    <div className={UNSAFE_className}>
      <CardsList
        title={tCatalog('thisCouldInterestYou')}
        cardList={displayedCollections.map((collection) => ({
          url: `/collections/${collection.handle}`,
          title: collection.titleLink || collection.title,
          image: collection.image || defaultCollectionVisualPath,
          alt: collection.title,
          id: collection.objectID,
        }))}
      />
    </div>
  );
};
